__turbopack_context__.v({
  "button": "style-module-scss-module__3MoYua__button",
  "buttonText": "style-module-scss-module__3MoYua__buttonText",
  "plusIcon": "style-module-scss-module__3MoYua__plusIcon",
});
